import {useEffect, useState} from "react";
import ImageUploader from "./Form/Fields/ImageUploader";
import Form from "./Form/Form";
import axios from "axios";
import { API_BASE_URL } from '../api';

const ProductImages = ({ product, productType, onCountChange }) => {
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (product?.id) {
            axios.get(`${API_BASE_URL}/api/v1/media?type=${productType}&id=${product.id}`, { withCredentials: true })
                .then(res => { setImages(res.data); onCountChange?.(res.data.length); })
                .catch(err => console.error("Failed to fetch product images", err));
        }
    }, [product, productType, onCountChange]);

    const handleUpload = async (files) => {
        const formData = new FormData();
        formData.append("type", productType);
        formData.append("id", product.id);

        files.forEach(file => formData.append("files", file));

        await axios.post("${API_BASE_URL}/api/v1/media/upload", formData, { withCredentials: true });
    };

    const handleDelete = async (imagesToDelete) => {
        try {
            await Promise.all(
                imagesToDelete.map(image =>
                    axios.delete(
                        `${API_BASE_URL}/api/v1/media/${image.id}`,
                        { withCredentials: true }
                    )
                )
            );

            setImages(prev => {
                const updated = prev.filter(img => !imagesToDelete.some(d => d.id === img.id));
                onCountChange?.(updated.length);
                return updated;
            });
        } catch (err) {
            console.error("Failed to delete media", err);
        }
    };


    return (
        <Form id="productImagesForm">
            <ImageUploader
                name="images"
                multiple={true}
                onUpload={handleUpload}
                onDelete={handleDelete}
                images={images} />
        </Form>
    );
};

export default ProductImages;
